import { SortingState } from '@tanstack/react-table';
import { FindAllQueryDto } from '../query/find-all-query.dto';
import { SortOrder } from './sort-order.enum';

export const sortingMapperToQuery = <Entity extends object>(sorting: SortingState): FindAllQueryDto<Entity>['sort'] => {
	return sorting.map((s) => ({ by: s.id as keyof Entity, order: s.desc ? SortOrder.DESC : SortOrder.ASC }));
};

export const sortingMapperToTable = <Entity extends object>(sorting: FindAllQueryDto<Entity>['sort']): SortingState | undefined => {
	return sorting?.map((s) => ({ id: s.by as string, desc: s.order === SortOrder.DESC }));
};
